import type {
  Faq,
  Problem,
  SavingRow,
  Stat,
  Testimonial,
  ValueRow,
} from '../types/content'

/** Link de pago real. Reemplazar por la URL del checkout (Mercado Pago, Hotmart, etc.). */
export const checkoutUrl = '#pricing'

export const heroStats: Stat[] = [
  { value: '$4.5M', label: 'ARS recuperados por año' },
  { value: '130g+', label: 'Proteína diaria garantizada' },
  { value: '12', label: 'Sistemas integrados' },
  { value: '$0', label: 'Suplementos innecesarios' },
]

export const problems: Problem[] = [
  {
    title: 'La "Fit-Tax" Invisible',
    description:
      'El yogur "probiótico" cuesta 3x más que el natural con las mismas bacterias. La granola "artesanal" tiene 28g de azúcar. El sistema alimentario cobra un impuesto al que quiere comer bien.',
  },
  {
    title: 'El Delivery de Emergencia',
    description:
      'Sin sistema de preparación, el miércoles a las 20:00 sin nada cocinado siempre termina igual: $8.000 ARS de delivery que se evitaban con 3 horas de trabajo el domingo.',
  },
  {
    title: 'Los Suplementos Inútiles',
    description:
      'BCAAs, colágeno, probióticos de farmacia. La industria vende lo que el sistema correcto ya provee: proteína completa, vitaminas reales y microbioma activo.',
  },
  {
    title: 'La Inflación sin Sistema',
    description:
      '289% de inflación alimentaria en 2 años. Sin sistema de compra y stock estratégico, cada mes la misma canasta cuesta más. La persona sin sistema pierde $150.000 ARS/mes sin notarlo.',
  },
]

export const solutionChecks: string[] = [
  'Ticket de compra reducido entre 30% y 45% sin cambiar la canasta nutricional',
  '21 comidas preparadas en 3 horas cada domingo. Cero deliverys de emergencia.',
  '130g+ de proteína diaria con los alimentos más económicos del mercado argentino',
  'Sensibilidad insulínica restaurada, microbioma activo y biohacking de costo cero',
  'Stock anti-inflación como instrumento financiero con ROI igual a la inflación futura',
]

export const savingRows: SavingRow[] = [
  { label: 'Tomo I — Compra Inteligente', amount: '$148.000 ARS/mes' },
  { label: 'Tomo II — Sin Delivery', amount: '$97.000 ARS/mes' },
  { label: 'Tomo IV — Sin Suplementos', amount: '$52.000 ARS/mes' },
  { label: 'Tomo V — Sin Azúcar Oculta', amount: '$44.000 ARS/mes' },
  { label: 'Bono 3 — Ayuno Intermitente', amount: '$24.000 ARS/mes' },
]

export const testimonials: Testimonial[] = [
  {
    name: 'Marcos G.',
    role: 'Estudiante de Medicina, CABA',
    quote:
      'El primer mes con el sistema activo ahorramos $312.000 ARS entre mi pareja y yo. Eso es literalmente un sueldo entero. No lo podía creer hasta que comparé los tickets.',
  },
  {
    name: 'Laura P.',
    role: 'Crossfitter, Rosario',
    quote:
      'Entreno 5 días por semana. Con el Tomo IV estoy más fuerte que nunca gastando $8.400 en proteínas donde antes gastaba $58.000. Sin Whey, sin BCAAs, sin nada de eso.',
  },
  {
    name: 'Rodrigo S.',
    role: 'Freelancer, Córdoba',
    quote:
      'El Bono Anti-Inflación solo valió el triple de lo que pagué. Compré stock en agosto y en noviembre esos alimentos costaban 140% más. El sistema se pagó solo en el primer mes.',
  },
]

export const resultStats: Stat[] = [
  { value: '+2.400', label: 'Personas con el sistema activo' },
  { value: '$379k', label: 'ARS ahorro mensual promedio' },
  { value: '4.8/5', label: 'Calificación promedio' },
  { value: '97%', label: 'Recomendaría el sistema' },
]

export const pricingTomos: string[] = [
  'Tomo I — Guerrilla en el Supermercado',
  'Tomo II — Meal Prep Blindado',
  'Tomo III — Cocina de Supervivencia',
  'Tomo IV — Anabólicos Naturales Low-Cost',
  'Tomo V — Detox de Azúcar en 7 Días',
  'Tomo VI — El Método de Escala Financiera',
]

export const pricingBonos: string[] = [
  'Bono 1 — Matrix de Sustitutos Baratos',
  'Bono 2 — Planificador de Menú Semanal',
  'Bono 3 — Guía Ayuno Intermitente 2.0',
  'Bono 4 — Guía de Fermentados Caseros',
  'Bono 5 — Recetario de Emergencia 15 Min',
  'Bono 6 — Guía Anti-Inflación Alimentaria',
]

export const upsellIncludes: string[] = [
  'Todo el Mega Pack: 6 Tomos + 6 Bonos',
  'Plan de 12 semanas periodizado, semana por semana',
  'Rutina de fuerza e hipertrofia sincronizada con las comidas',
  'Ajuste de macros por fase: recomposición, volumen y definición',
  'Checklists de seguimiento y métricas de progreso',
  'Protocolo de recuperación, sueño y manejo del estrés',
]

export const valueStack: ValueRow[] = [
  { label: '6 Tomos (300 págs. premium)', amount: '$90.000' },
  { label: 'Bono 1 — Matrix de Sustitutos', amount: '$29.000' },
  { label: 'Bono 2 — Planificador Semanal', amount: '$29.000' },
  { label: 'Bono 3 — Guía Ayuno Intermitente', amount: '$29.000' },
  { label: 'Bono 4 — Fermentados Caseros', amount: '$29.000' },
  { label: 'Bono 5 — Recetario 15 Min', amount: '$29.000' },
  { label: 'Bono 6 — Anti-Inflación', amount: '$29.000' },
]

export const faqs: Faq[] = [
  {
    question: '¿Funciona si vivo solo o soy estudiante?',
    answer:
      'El sistema fue diseñado exactamente para esa situación. El Tomo II reduce la cocina semanal a 3 horas el domingo. El Bono 5 tiene 50 recetas de 15 minutos para los días que fallás.',
  },
  {
    question: '¿Necesito conocimientos de nutrición o cocina?',
    answer:
      'No. El sistema tiene protocolos paso a paso, tablas de referencia y checklists. El 80% del sistema es organización y compra inteligente, no técnica culinaria compleja.',
  },
  {
    question: '¿Es compatible con entrenamiento de fuerza?',
    answer:
      'El Tomo IV está específicamente diseñado para síntesis proteica muscular. El sistema garantiza 130g+ de proteína diaria con los alimentos más económicos del mercado argentino.',
  },
  {
    question: '¿Funciona fuera de Buenos Aires?',
    answer:
      'Sí. Los principios aplican en todo el país. El Bono 6 incluye una guía de adaptación para encontrar los canales de compra equivalentes en cualquier ciudad argentina.',
  },
  {
    question: '¿Qué formato tiene el producto?',
    answer:
      'Son archivos PDF en formato A4 diseñados para impresión de alta calidad. El Bono 1 y el Bono 2 están específicamente pensados para imprimir y pegar en la heladera.',
  },
  {
    question: '¿Cómo accedo después de la compra?',
    answer:
      'Acceso inmediato por email. Descarga directa desde el primer minuto. Sin suscripciones, sin membresías, sin renovaciones. El acceso es permanente.',
  },
]
